import { render, staticRenderFns } from "./UncheckedOkSpecialOfferReceipt.vue?vue&type=template&id=4ff3ba93&scoped=true&"
import script from "./UncheckedOkSpecialOfferReceipt.vue?vue&type=script&lang=ts&"
export * from "./UncheckedOkSpecialOfferReceipt.vue?vue&type=script&lang=ts&"
import style0 from "./UncheckedOkSpecialOfferReceipt.vue?vue&type=style&index=0&id=4ff3ba93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff3ba93",
  null
  
)

export default component.exports